import {
  Component,
  ContentChild,
  HostBinding,
  Input,
  type TemplateRef,
} from '@angular/core';
import { Offer } from '@innogy/become-a-customer/shared/interfaces';
import {
  SkeletonLoaderMask,
  SvgSkeletonLoaderComponent,
} from '@legacy/common-ui-shared';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';

import { accordionBodyMask, accordionHeaderMask } from '../svg-skeleton-masks';
import { CommonModule } from '@angular/common';
import { TrackInteractionDirective } from '@analytics/events';

@Component({
  selector: 'wl-commodity-offer-accordion',
  templateUrl: './commodity-offer-accordion.component.html',
  styleUrls: [
    './commodity-offer-accordion.component.ed.scss',
    './commodity-offer-accordion.component.essent.scss',
  ],
  host: { ngSkipHydration: 'true' },
  standalone: true,
  imports: [
    CommonModule,
    NgbAccordionModule,
    SvgSkeletonLoaderComponent,
    TrackInteractionDirective,
  ],
})
export class CommodityOfferAccordionComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() offer?: Offer;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() opened = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showLoadingState = false;

  @ContentChild('accordionHeader') accordionHeader!: TemplateRef<any> | null;
  @ContentChild('accordionBody') accordionBody!: TemplateRef<any> | null;

  @HostBinding('attr.data-offerid')
  get offerId() {
    return this.offer?.offerId;
  }

  get maskHeader(): SkeletonLoaderMask {
    return accordionHeaderMask;
  }

  get maskBody(): SkeletonLoaderMask {
    return accordionBodyMask;
  }
}
